import {
  DEFAULT_SECTION_CONTAINER_PROPS,
  EMAIL_ELEMENT_CONTAINER_PROPS_OVERRIDES,
} from '@kizen/page-builder/nodes/containers';

export const DEFAULT_EMAIL_SECTION_PROPS = {
  ...DEFAULT_SECTION_CONTAINER_PROPS,
  ...EMAIL_ELEMENT_CONTAINER_PROPS_OVERRIDES,
};

export const DEFAULT_FORM_SECTION_PROPS = DEFAULT_SECTION_CONTAINER_PROPS;
